export default __webpack_public_path__ + "static/media/circle-solid.fb851a0a.svg";